__turbopack_context__.v({
  "fadeEnterActiveLeft": "Images-module__YV70PG__fadeEnterActiveLeft",
  "fadeEnterActiveRight": "Images-module__YV70PG__fadeEnterActiveRight",
  "fadeEnterLeft": "Images-module__YV70PG__fadeEnterLeft",
  "fadeEnterRight": "Images-module__YV70PG__fadeEnterRight",
  "fadeExitActiveLeft": "Images-module__YV70PG__fadeExitActiveLeft",
  "fadeExitActiveRight": "Images-module__YV70PG__fadeExitActiveRight",
  "fadeExitLeft": "Images-module__YV70PG__fadeExitLeft",
  "fadeExitRight": "Images-module__YV70PG__fadeExitRight",
});
